import widgets from "@beeldit/core/widgets/widgets";
import CustomerSelector from "@main/customers/components/CustomerSelector";

const filterUIConfig = {
    uiScheme: {
        classNames: "filters-container",
        receiver_customer_id: {
            "ui:widget": "customer-selector",
            "ui:options": {
                label: false,
            }
        },
        search: {
            "ui:options": {
                label: false,
                placeholder: "Buscar..."
            }
        },
        start_date: {
            "ui:options": {
                label: true,
                placeholder: "Desde",
                title: "Desde"
            }
        },
        end_date: {
            "ui:options": {
                label: true,
                placeholder: "Hasta",
                title: "Hasta"
            }
        },
        
    },
    widgets: {
        ...widgets,
        "customer-selector": CustomerSelector,
    }
}
const getFilterUIConfig: any = (type: string) => {
    return filterUIConfig;
}
export default getFilterUIConfig;
